import { render, staticRenderFns } from "./VoteRanking.vue?vue&type=template&id=3f4fe505&scoped=true"
import script from "./VoteRanking.vue?vue&type=script&lang=js"
export * from "./VoteRanking.vue?vue&type=script&lang=js"
import style0 from "./VoteRanking.vue?vue&type=style&index=0&id=3f4fe505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4fe505",
  null
  
)

export default component.exports